// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__12XPc","boxTitle":"Qualiphy_boxTitle__3phBJ","box":"Qualiphy_box__35aS2","toggleWrap":"Qualiphy_toggleWrap__3pAMF"};